import {
  UTM_COOKIE_MAX_AGE_SECONDS,
  UTM_COOKIE_TO_LEAD_FIELD,
  buildUtmCookieWrites,
  decodeUtmCookie,
  destinationUrlForLead,
  encodeUtmCookie,
  mapUtmCookiesToLeadFields,
} from '../utils/utm-attribution'

const cookieOptions = {
  maxAge: UTM_COOKIE_MAX_AGE_SECONDS,
  sameSite: 'lax',
  path: '/',
  decode: decodeUtmCookie,
  encode: encodeUtmCookie,
}

const utmCookieRefs = () => {
  const refs = {}
  for (const cookieName of Object.keys(UTM_COOKIE_TO_LEAD_FIELD)) {
    refs[cookieName] = useCookie(cookieName, cookieOptions)
  }
  return refs
}

const readStoredAttribution = (refs) => {
  const cookies = {}
  for (const [cookieName, cookie] of Object.entries(refs)) {
    cookies[cookieName] = cookie.value ?? ''
  }
  return cookies
}

/**
 * Persist campaign params from the current URL. Pages without UTMs leave
 * existing cookies alone, so attribution is still available at submit time.
 */
export const useUtmAttributionCapture = () => {
  const route = useRoute()
  const cookies = utmCookieRefs()
  const staleDestinationUrl = useCookie('utmDestinationUrl', cookieOptions)

  const capture = () => {
    if (staleDestinationUrl.value) staleDestinationUrl.value = null

    const userAgent = import.meta.client
      ? window.navigator?.userAgent || ''
      : useRequestHeaders(['user-agent'])['user-agent'] || ''
    const stored = readStoredAttribution(cookies)
    const writes = buildUtmCookieWrites({
      query: route.query || {},
      userAgent,
      now: new Date(),
      existing: {
        utmSiteVisitDate: stored.utmSiteVisitDate,
      },
    })

    for (const [name, value] of Object.entries(writes)) {
      cookies[name].value = value || null
    }
  }

  capture()
  watch(() => route.fullPath, capture)
}

/** Copy stored attribution onto a lead payload using the Lead event field names. */
export const applyUtmAttribution = (payload) => {
  const currentUrl = import.meta.client
    ? window.location?.href || ''
    : useRequestURL()?.href || ''

  return {
    ...payload,
    ...destinationUrlForLead(
      mapUtmCookiesToLeadFields(readStoredAttribution(utmCookieRefs())),
      currentUrl,
    ),
  }
}
